
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"160","height":"332"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M137 332H25c-12.7 0-23-10.3-23-23V25C2 12.3 12.3 2 25 2h112c12.7 0 23 10.3 23 23v284c0 12.7-10.3 23-23 23zM25 4C13.4 4 4 13.4 4 25v284c0 11.6 9.4 21 21 21h112c11.6 0 21-9.4 21-21V25c0-11.6-9.4-21-21-21H25zM0 48h2v15H0zM0 79h2v12H0zM0 106h2v12H0z"}}),_c('path',{attrs:{"d":"M92 34H69c-1.7 0-3-1.3-3-3s1.3-3 3-3h23c1.7 0 3 1.3 3 3s-1.3 3-3 3zm-23-4c-.6 0-1 .4-1 1s.4 1 1 1h23c.6 0 1-.4 1-1s-.4-1-1-1H69zM80 22c-2.2 0-4-1.8-4-4s1.8-4 4-4 4 1.8 4 4-1.8 4-4 4zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM59 34c-1.7 0-3-1.3-3-3s1.3-3 3-3 3 1.3 3 3-1.3 3-3 3zm0-4c-.6 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zM82 322c-7.7 0-14-6.3-14-14s6.3-14 14-14 14 6.3 14 14-6.3 14-14 14zm0-26c-6.6 0-12 5.4-12 12s5.4 12 12 12 12-5.4 12-12-5.4-12-12-12z"}}),_c('path',{attrs:{"d":"M13 47h136v240H13z","opacity":".1"}}),_c('path',{attrs:{"d":"M150 288H12V46h138v242zm-136-2h134V48H14v238zM107 0h26v2h-26z"}}),_c('g',[_c('path',{attrs:{"d":"M14 288l53.9-96.3M96 141.6L149 47","opacity":".1"}}),_c('path',{attrs:{"d":"M14.9 288.5l-1.7-1L67 191.3l1.7 1-53.8 96.2zm82-146.4l-1.7-1 53-94.6 1.7 1-53 94.6z"}})])])
          )
        }
      }
    